module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "Auth-"
    }
  }, [(_vm.authenticate) ? _c('div', {
    staticClass: "Auth"
  }, [_c('div', {
    staticClass: "Auth-header t-antialiased"
  }, [_c('div', {
    staticClass: "Auth-headerContainer"
  }, [_c('icon', {
    staticClass: "Auth-headerLock",
    attrs: {
      "name": "lock",
      "width": "14.839px",
      "height": "18px"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "t-heading-caps c-white"
  }, [_vm._v("Protected area")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.initialized),
      expression: "initialized"
    }],
    staticClass: "Auth-content"
  }, [_c('text-input', {
    ref: "password",
    staticClass: "Auth-password",
    attrs: {
      "placeholder": "Enter password",
      "type": "password",
      "large": "",
      "focus": ""
    },
    on: {
      "submit": _vm.submit,
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close.apply(null, arguments)
      }]
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "Auth-feedback t-text-sm c-grey-lt"
  }, [_c('break'), _vm._v("\n        " + _vm._s(_vm.message) + "\n      ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Auth-footer t-antialiased"
  }, [_c('p', {
    staticClass: "Auth-message t-text-sm c-grey-lt"
  }, [_vm._v("\n        Not working? "), _c('a', {
    attrs: {
      "href": ("mailto:" + (_vm.global.site.email.value))
    }
  }, [_vm._v("Contact us")]), _vm._v(" or visit the "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("home page")]), _vm._v(".\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "Auth-backdrop",
    on: {
      "click": _vm.close
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a695e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth.vue
// module id = 771
// module chunks = 1474